// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"MyBalance__balanceWrapper--1T5","icon":"MyBalance__icon--3nt","balance":"MyBalance__balance--hUh","balanceLow":"MyBalance__balanceLow---Yd"};